<template>
  <div class="static-page">
    <pages-wrapper>
      <div
        class="static-page-content html-content"
        v-html="PAGE_CONTENT"
      />
    </pages-wrapper>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
/* Components */
import PagesWrapper from '../components/info-pages/pages-wrapper';

export default {
  name: 'static_page',
  components: {
    PagesWrapper
  },

  computed: {
    ...mapGetters({
      PAGE_CONTENT: 'staticPages/page'
    })
  },

  methods: {
    ...mapActions({
      LOAD_STATIC_PAGE: 'staticPages/loadStaticPage'
    }),
  },

  serverPrefetch() {
    return this.LOAD_STATIC_PAGE();
  }
};
</script>

<style lang="scss">
.static-page {
  //
}
</style>